module.exports = __webpack_public_path__ + "static/media/bgPark1.3e45dd7b.jpg";